import { render, staticRenderFns } from "./EditHubDetailsModal.vue?vue&type=template&id=6c7f9e50"
import script from "./EditHubDetailsModal.vue?vue&type=script&lang=js"
export * from "./EditHubDetailsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports